module.exports = __webpack_public_path__ + "img/ejaf-erp4.f570deaa.png";